import React, { Fragment } from 'react';
import { PhysicianField, DNRField } from './BasicComponents';

export const DNRPhys = (props) => (
  <Fragment>
    <PhysicianField {...props} />
    <DNRField {...props} />
  </Fragment>
);
